import { Box } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';

// компонент для отображения загрузки
export default function Loading({ progress = undefined }) {
    const showProgress = progress !== undefined && progress !== null;

    return (
        <Box 
            display="flex" 
            justifyContent="center" 
            alignItems="center" 
            sx={{ height: "100%", position: "relative" }}
        >
            <CircularProgress 
                variant={showProgress ? "determinate" : "indeterminate"}
                value={showProgress ? progress : undefined}
                sx={{
                    circle: {
                        fill: 'transparent',
                    },
                }} 
            />
            {showProgress && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        pointerEvents: "none",
                    }}
                >
                    {Math.round(progress)}%
                </Box>
            )}
        </Box>
    );
}